import React from 'react';
import PropTypes from 'prop-types';
import { Input } from 'sabre-spark-react';
import { SANITIZATION_TYPES, AngleBrackets, Regexp, WhiteList, BlackList, sanitize } from './sanitizationTypes';

export default class InputTextField extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            value: props.value || props.defaultValue || '',
            errorMessage: null
        };
        this._onInput = this._onInput.bind(this);
        this.clearError = this.clearError.bind(this);
        this.listenerProxy = this.listenerProxy.bind(this);
        this.isSpark = props.useSparkInput || !_.isEmpty(props.sparkInputProps);
        this.value = this.state.sanitizedValue = sanitize(this.state.value);
    }
    timeout: null;
    isSpark: false;
    value: '';
    input: null;

    componentDidUpdate(prevProps, prevState, snapshot) {
        this.value = this.state.sanitizedValue;
    }

    render() {
        const {
            autoComplete,
            className,
            defaultValue,
            disabled,
            id,
            name,
            maxLength,
            onBlur,
            onChange,
            onFocus,
            onKeyPress,
            onKeyUp,
            placeholder,
            ref,
            required,
            role,
            sparkInputProps = {},
            style
        } = this.props;
        const value = this.state.value;
        const sanitizedValue = this.state.sanitizedValue;
        const errorMessage = this.state.errorMessage || sparkInputProps.errorMessage;
        const attributes = {
            autoComplete,
            className,
            defaultValue,
            disabled,
            id,
            name: `${name || ''}Helper`,
            maxLength,
            onBlur: this.listenerProxy(onBlur),
            onChange: this.isSpark ? this._onInput : onChange,
            onFocus: this.listenerProxy(onFocus),
            onKeyPress: this.listenerProxy(onKeyPress),
            onKeyUp: this.listenerProxy(onKeyUp),
            placeholder,
            required,
            role,
            style,
            value
        };
        const attributesForHidden = {
            type: 'hidden',
            name,
            defaultValue,
            value: sanitizedValue,
            maxLength,
            required
        };

        if (this.isSpark) {
            return (
                <div>
                    <Input errorMessage={errorMessage} {...sparkInputProps} {...attributes} />
                    <input {...attributesForHidden} />
                </div>
            );
        }

        attributes.onInput = this._onInput;
        attributes.ref = ref;

        return (
            <div className="InputTestField" data-error={(!!errorMessage).toString()}>
                <input {...attributes} />
                <input {...attributesForHidden} ref={e => (this.input = e)} />
                {errorMessage ? <span className="error_message">{errorMessage}</span> : null}
            </div>
        );
    }

    _onInput(event) {
        const callback = this.isSpark ? this.props.onChange : this.props.onInput;
        const value = this.isSpark ? event : (event.target || { value: '' }).value;
        const sanitizedData = this.removeFromInput(value)
        this.setState(sanitizedData);
        if (typeof callback === 'function') callback(_.get(sanitizedData, 'value', ''));
    }

    removeFromInput(val) {
        let value = '';
        switch (this.props.sanitizationType) {
            case SANITIZATION_TYPES.BLACK_LIST:
                value = BlackList(this.props.blackList, val);
                break;
            case SANITIZATION_TYPES.WHITE_LIST:
                value = WhiteList(this.props.whiteList, val);
                break;
            case SANITIZATION_TYPES.REGEXP:
                value = Regexp(this.props.sanitizeRegExp, val);
                break;
            default:
                value = AngleBrackets(val);
        }
        return {
            value,
            sanitizedValue: sanitize(value, this.props.replaceInValue)
        };
    }

    clearError() {
        this.setState({ errorMessage: null });
        if (this.timeout) clearTimeout(this.timeout);
        this.timeout = null;
    }

    listenerProxy(listener) {
        if (!listener) return;

        return event => {
            listener(Object.assign(event, { target: this.input || { value: this.value } }));
        };
    }
}
const sanitizationTypes = Object.keys(SANITIZATION_TYPES).map(key => SANITIZATION_TYPES[key]);

InputTextField.propTyps = {
    autoComplete: PropTypes.string,
    blackList: PropTypes.arrayOf(PropTypes.string),
    className: PropTypes.string,
    defaultValue: PropTypes.string,
    disabled: PropTypes.bool,
    id: PropTypes.string,
    name: PropTypes.string,
    maxLength: PropTypes.number,
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
    onFocus: PropTypes.func,
    onInput: PropTypes.func,
    onKeyPress: PropTypes.func,
    onKeyUp: PropTypes.func,
    placeholder: PropTypes.string,
    ref: PropTypes.any,
    replaceInValue: PropTypes.oneOfType([
        PropTypes.func,
        PropTypes.objectOf(PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(RegExp)]))
    ]),
    required: PropTypes.bool,
    role: PropTypes.string,
    sanitizationType: PropTypes.oneOf(sanitizationTypes),
    sanitizeRegExp: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(RegExp)]),
    style: PropTypes.shape({}),
    sparkInputProps: PropTypes.shape({
        charsCount: PropTypes.bool,
        errorMessage: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
        icon: PropTypes.string,
        label: PropTypes.string,
        multiline: PropTypes.bool,
        thinLabel: PropTypes.string,
        type: PropTypes.string,
        typeAheadFormat: PropTypes.string,
        pattern: PropTypes.string
    }),
    useSparkInput: PropTypes.bool,
    value: PropTypes.string,
    whiteList: PropTypes.arrayOf(PropTypes.string)
};



// WEBPACK FOOTER //
// ./src/components/common/InputTextField.js